/* eslint-disable react/jsx-no-bind */
//@flow

import * as React from 'react';
import * as Immutable from 'immutable';
import { useTranslation } from 'react-i18next';
import { Stack, Text } from '@locus-taxy/neo-ui';

import TransporterTeams from './TransporterTeams';
import Select from 'common/components/core/select/Select';
import { FormField } from 'common/components/core/form/FormField';

import { TransporterId } from 'common/models/internal/TransporterId';
import EntityStatusEnum, {
    type EntityStatusEnumType
} from 'common/enums/EntityStatusEnum';

import { Team } from 'common/models/internal/Team';

type Value = Immutable.List<TransporterId>;
type Props = {
    value: Value,
    onChange: (value: Value) => void,
    placeholder: string,
    teams: Array<Team>,
    transporters: Array<{
        transporterId: TransporterId,
        name: string,
        status: EntityStatusEnumType
    }>,
    clientId: string,
    error: ?string
};

const TransporterInput = ({
    teams,
    value,
    onChange,
    transporters,
    clientId,
    error
}: Props): React.Node => {
    const getId = value => {
        return value && value.size > 0 ? value.get(0).transporterId : null;
    };

    const [initialValue] = React.useState(() => getId(value));
    const { t } = useTranslation('entityManagement');

    const transporter = getId(value);

    const options = React.useMemo(() => {
        return transporters
            .filter(transporter => {
                if (transporter.status === EntityStatusEnum.ACTIVE) {
                    return true;
                }

                // include inactive in option if assigned
                return transporter.transporterId.transporterId === initialValue;
            })
            .map(transporter => {
                return {
                    label: transporter.name,
                    value: transporter.transporterId.transporterId
                };
            });
    }, [transporters, initialValue]);

    return (
        <Stack space="small">
            <div>
                <Select
                    placeholder={t(
                        'masterPersonnelForm.transporterIdPlaceholder'
                    )}
                    value={transporter}
                    options={options}
                    hasError={Boolean(error)}
                    onChange={option => {
                        onChange(
                            Immutable.List(
                                option
                                    ? [
                                          TransporterId.fromJS({
                                              transporterId: option.value,
                                              clientId
                                          })
                                      ]
                                    : []
                            )
                        );
                    }}
                />
                {error ? <Text>{error}</Text> : null}
            </div>
            {transporter ? (
                <FormField
                    column
                    fullWidth
                    label={t('masterPersonnelForm.teams')}
                >
                    <TransporterTeams
                        clientId={clientId}
                        transporterId={transporter}
                        allTeams={teams}
                    />
                </FormField>
            ) : null}
        </Stack>
    );
};

export default TransporterInput;
